import { filter } from 'lodash/fp';
import { selectProject, selectSelectedEntityId } from 'app/store/projects/selectors.js';
import { selectWorkbenchDatasetTabForEntityId } from 'app/store/preferences/selectors';
import { doGetTransformSql } from 'app/store/transformSql/actions.js';
import { selectQueryListForPropEntityId } from 'app/store/exploreData/selectors.js';
import {
    doDeleteDatasetQuery,
    doInvalidateExploreQueries
} from 'app/store/snowflakeQueries/actions.js';
import { INVALIDATE_DATASET, INVALIDATE_DOWNSTREAM_DATASETS } from './types.js';

const doInvalidateDataset = ({ entityId } = {}) => ({
    type: INVALIDATE_DATASET,
    payload: { entityId }
});

function invalidate({ store, space, viewUid, keepCacheValid }) {
    const state = store.getState();
    const selectedEntityId = selectSelectedEntityId(state);
    const selectedTab = selectWorkbenchDatasetTabForEntityId(state, { entityId: selectedEntityId });
    const entityId = `${space.uid}.${viewUid}`;
    const dependencies = filter((d) => d.toView === viewUid, space.dependencies);
    const explorationQueries = selectQueryListForPropEntityId(state, { entityId });

    store.dispatch(doInvalidateDataset({ entityId }));
    store.dispatch(doDeleteDatasetQuery({ entityId }));

    if (explorationQueries !== null) {
        store.dispatch(doInvalidateExploreQueries(explorationQueries));
    }

    if (selectedTab === 'sql' && selectedEntityId === entityId) {
        store.dispatch(doGetTransformSql(entityId));
    }

    for (const dependency of dependencies) {
        invalidate({
            store,
            space,
            viewUid: dependency.fromView,
            keepCacheValid
        });
    }
}

export const doInvalidateDownstreamDatasets = ({ ids, keepCacheValid = false }) => ({
    type: INVALIDATE_DOWNSTREAM_DATASETS,
    effect: ({ store }) => {
        const state = store.getState();
        const space = selectProject(state);
        for (const viewUid of ids) {
            invalidate({ store, space, viewUid, keepCacheValid });
        }
    }
});
